export const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'blog', label: 'Blog' },
  { id: 'quotes', label: 'Quotes' },
  { id: 'poems', label: 'Poems' },
  { id: 'admin', label: 'Admin' },
];

export const NOTION_RESOURCES = [
  { title: 'Reading Diary', description: 'Daily reflections from reading books & articles.', id: 'diary' },
  { title: 'Bank Idea', description: 'A repository of thoughts and sparks.', id: 'bank-idea' },
  { title: 'Poems', description: 'Metrical compositions and verses.', id: 'poems' },
];